const imp = () => import(/* webpackChunkName: "loadSprite_message_line"*/  "../sprite/loadSprite_message_line");
const loadMap_message_line: { [key: string]: () => Promise<any> } = {
  "Icon-Bold-o": imp,
  "Icon-Disordered-arrangement-o": imp,
  "Icon-Don't-disturb-o": imp,
  "Icon-Hang-up-o": imp,
  "Icon-link02-o": imp,
  "Icon-Message-attachment-o": imp,
  "Icon-Message-module-table-o": imp,
  "Icon-Message-read-o": imp,
  "Icon-Message-tag-read-o": imp,
  "Icon-Message-voice-o": imp,
  "Icon-News-customer-service-o": imp,
  "Icon-News-video-o": imp,
  "Icon-On-the-phone-o": imp,
  "Icon-Orderly-arrangement-o": imp,
  "Icon-Quotation-marks-o": imp,
  "Icon-Recording-o": imp,
  "Icon-Video-off-o": imp,
  "Icon-Voice-off-o": imp,
  "Icon-answer-the-phone-o": imp,
  "Icon-backstage-o": imp,
  "Icon-quote-o": imp,
  "Icon-reply-o": imp,
  "Icon-strikethrough-o": imp,
  "Icon-Message-picture-o": imp,
  "Icon-News-video02-o": imp,
  "Icon-External-Contacts-o": imp,
  "Icon-organizational-structure-o": imp,
  "Icon-recent-contacts-o": imp,
  "Icon-Audio-and-video-o": imp,
  "Icon-Bida-o": imp,
  "Icon-Common-words-o": imp,
  "Icon-Message-anonymity-o": imp,
  "Icon-Message-logging-o": imp,
  "Icon-News-collection-o": imp,
  "Icon-News-sharing-o": imp,
  "Icon-Message-file-o": imp,
  "Icon-News@-o": imp,
  "Icon-expression-o": imp,
  "Icon-Shake-it-o": imp,
  "Icon-business-card-o": imp,
  "Icon-written-words-o": imp,
  "Icon-screenshot-o": imp,
  "Icon-topic-of-conversation-o": imp,
  "Icon-Folder-o": imp,
  "Icon-Folder02-o": imp,
  "Icon-Bida-1": imp,
  "Icon-Add-external-contacts": imp,
  "Icon-Add-group02": imp,
  "Icon-Management-background": imp,
  "Icon-Preferences": imp,
  "Icon-addemoji": imp,
  "Icon-Documentation-o": imp,
  "Icon-Groupannouncement-o": imp,
  "Icon-plusone": imp,
  "Icon-Solitaire": imp,
  "Icon-deallater": imp,
}
export default loadMap_message_line;
